// Constants extracted from PusherModule.js

// Constants
export const NAME = "pusher";
export const HANDLE_FOCUSED_FIELD = "HANDLE_FOCUSED_FIELD" + " " + NAME;
export const INIT_LOCKED_FIELD = "INIT_LOCKED_FIELD" + " " + NAME;
export const TYPE_TO_PRESENCE_EVENTS_MAPPING = {
  unitPlan: "updateUnitPlanLock",
  le: "updateLeLock",
  assessment: "updateAssessmentLock",
  project: "updateProjectLock",
  ayt: "updateAytLock",
};
export const TYPE_TO_BLUR_FIELD_EVENTS_MAPPING = {
  unitPlan: "blurUnitPlanField",
  le: "blurLeField",
  assessment: "blurAssessmentField",
  project: "blurProjectField",
};
